const lightColors = {
  Appgreen: 'rgba(19, 181, 140, 1)',
  LightGreen: 'rgba(223, 251, 244, 1)',
  Lightgray: 'rgba(220, 220, 220, 1)',
  Appgray: '#4D5858',
  UltraGray: 'rgba(247, 247, 247, 1)',
  SimonGray: '#E6E7E7',
  AppRed: 'rgba(250, 92, 92, 1)',
  AppLightGreen: '#FAFBFB',
  UltraGreen: '#F2F6F6',
  AppNewGreen: '#01544E',
  AppCGreen: '#EEFEFC',
  UltraLightGreen: '#DDF3F2',
  SwitchColor: '#CCDDDC',
  AppYellow: '#FFCA1E',
  TransparentColor: 'rgba(76, 175, 80, 0.0)',
  BackgroundBlueColor: 'rgba(246, 249, 255, 1)',
  BGBlueColor: '#33a9db',
  AppGreenBorder: '#CCCFCF',
  AppButtonRed: '#FFC9C9',
  UltraLightRed: '#FCEFEF',
  AppButtonGreen: '#AEEAD1',
  orangeColor: '#FFA500',
  AppLightOrange: '#fce6bd',
  blueColor: '#054df5',
  GradientColors: [
    ['#01544E', '#077B73'],
    ['#01544E', '#077B73'],
  ],
  GradientRedColors: [
    ['#A52A2A', '#A52A2A'],
    ['#A52A2A', '#A52A2A'],
  ],
  GradientGrayColors: [
    ['#565656', '#565656'],
    ['#565656', '#565656'],
  ],
  GradientWhiteColors: [
    ['#000000', '#000000'],
    ['#000000', '#000000'],
  ],
  blackColor: 'black',
  transparentBlackColor: 'rgba(0, 0, 0, 0.5)',
  darkRed: '#A52A2A',
  lightRed: '#fecdd3',
  CGreen: '#a7f3d0',
  AppWhite: 'white',
  AppTitleBlack: '#1A2928',
  lightYellow: 'rgba(255,199,0,0.15)',
  lightOrange: '#ef8162',
  cyanColor: '#E8FFFA',
  toolTipBGColor: '#31cd87',
  previewColor: '#364935',
  PaidBGColor: '#B4F0E5',
  PaidOutlineColor: '#0FB5A9',
  placeholderColor: '#99A09F',
  LightDarkGray: '#bdbbbb',
  darkGray: '#565656',

  // Semantic tokens — match CSS vars in index.css :root
  screenBackground: '#f7f7f7',
  cardBackground: '#ffffff',
  borderColor: '#e6e7e7',
  tableHeaderBackground: '#fafbfb',
  primaryText: '#1A2928',
  secondaryText: '#4D5858',
  inputBackground: '#ffffff',
};

const darkColors = {
  ...lightColors,

  // Overrides for dark mode
  Lightgray: '#3A3A3A',
  UltraGray: '#1E1E1E',
  SimonGray: '#3A3A3A',
  AppLightGreen: '#1A1A1A',
  UltraGreen: '#1E2A28',
  AppCGreen: '#0D2421',
  UltraLightGreen: '#0D2421',
  SwitchColor: '#2A3E3C',
  AppGreenBorder: '#2A3A38',
  AppButtonRed: '#4A1A1A',
  UltraLightRed: '#2A1515',
  AppButtonGreen: '#1A3A2A',
  BackgroundBlueColor: '#1A1E2A',
  lightYellow: 'rgba(255,199,0,0.10)',
  cyanColor: '#0D1F1C',
  AppWhite: '#1E1E1E',
  AppTitleBlack: '#F0F0F0',
  Appgray: '#A0ABAB',
  placeholderColor: '#6A7A79',
  LightDarkGray: '#4A4A4A',
  blackColor: 'white',
  transparentBlackColor: 'rgba(255,255,255,0.15)',

  // Semantic surface tokens
  screenBackground: '#111111',
  cardBackground: '#1e1e1e',
  borderColor: '#2e2e2e',
  tableHeaderBackground: '#1a1a1a',
  primaryText: '#f0f0f0',
  secondaryText: '#a0abab',
  inputBackground: '#2a2a2a',

  // Brand green lightened for dark backgrounds so interactive elements remain visible
  AppNewGreen: '#2DC4B8',
};

export {lightColors, darkColors};

// Default export stays the light palette so existing imports don't break
export default lightColors;
